import { useEffect, useState } from 'react'
import Latex from 'react-latex-next'
// redux
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { BloqueState, setBloque } from '../../store/slices/bloque'
import { SeccionState, setSeccion } from '../../store/slices/seccion'
// mui components

// mui icons

// componentes propios
import MenuSeccion from './MenuSeccion'

import EliminarSeccion from './EliminarSeccion'
import EditarSeccion from './EditarSeccion'
import MenuCrearEjercicio from './Ejercicios/MenuCrearEjercicio'

import AddIcon from '@mui/icons-material/Add';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import CalculateIcon from '@mui/icons-material/Calculate';

import { crearSeccionDiapositiva, eliminarSeccionDiapositiva } from '../../store/slices/seccion-diapositiva'
import EditarDiapositiva from './Diapositivas/EditarDiapositiva'
import EliminarDiapositiva from './Diapositivas/EliminarDiapositiva'
import Modal from './Diapositivas/Modal'
import ModalCrearEjercicio from './Ejercicios/FormulariosCrearEditar/ModalCrearEjercicio'
import { eliminarSeccionEjercicio } from '../../store/slices/seccion-ejercicio'
import { SeccionEjercicioState, setSeccionEjercicio } from '../../store/slices/seccion-ejercicio/seccionEjercicioSlice';
import ModalEditarEjercicio from './Ejercicios/FormulariosCrearEditar/ModalEditarEjercicio'


type Props = {
  bloque: BloqueState
}

const SeccionesEdicion = ({ bloque }: Props) => {

  const dispatch = useDispatch<AppDispatch>();

  const { usuario } = useSelector((state: RootState) => state.usuario);
  const { secciones, isLoading, seccion } = useSelector((state: RootState) => state.seccion);

  const [seccionesBloque, setSeccionesBloque] = useState<Array<SeccionState>>([])
  const [tipo, seTipo] = useState('');

  useEffect(() => {
    const seccionesBloque = secciones.filter(item => item.bid === bloque.bid);
    setSeccionesBloque(seccionesBloque);
  }, [secciones, bloque, seccion]);

  // Eliminar Seccion
  const [openEliminar, setOpenEliminar] = useState(false);

  const handleEliminarSeccion = (seccion: SeccionState) => {
    dispatch(setSeccion(seccion));
    setOpenEliminar(true)
  }

  // Editar Seccion
  const [openEditar, setOpenEditar] = useState(false);

  const handleEditarSeccion = (seccion: SeccionState) => {
    dispatch(setSeccion(seccion));
    setOpenEditar(true)
  }

  // Crear Diapositiva
  const [openEditarDiapositiva, setOpenEditarDiapositiva] = useState(false);

  const handleCrearDiapositiva = async (seccion: SeccionState) => {
    console.log('Crear Diapositivas')
    const nuevaDiapositiva = {
      cid: seccion.cid,
      mid: seccion.mid,
      bid: seccion.bid,
      sid: seccion.sid,
      autor: `${usuario.nombre} ${usuario.apellido}`,
      diapositivas: [
        { pagina: 1, contenido: 'Edite esta diapositiva' }
      ]
    }

    const seccionActualizada = await dispatch(crearSeccionDiapositiva(nuevaDiapositiva));

    if (seccionActualizada) {
      dispatch(setSeccion(seccionActualizada));
      dispatch(setBloque(bloque));
      setOpenEditarDiapositiva(true)
    }
  }


  // Eliminar Diapositiva
  const [openEliminarDiapositiva, setOpenEliminarDiapositiva] = useState(false);

  const handleEliminarDiapositiva = (seccion: SeccionState) => {
    console.log('Eliminar Diapositiva')
    dispatch(setSeccion(seccion));
    setOpenEliminarDiapositiva(true)
  }

  // Editar Diapositiva
  const handleEditarDiapositiva = (seccion: SeccionState) => {
    console.log('Editar Diapositiva')
    dispatch(setSeccion(seccion));
    dispatch(setBloque(bloque));
    setOpenEditarDiapositiva(true)
  }

  // Crear Ejercicio
  const [openCrearEjercicio, setOpenCrearEjercicio] = useState(false);

  const handleCrearEjercicio = (seccion: SeccionState, tipo: string) => {
    dispatch(setSeccion(seccion));
    setOpenCrearEjercicio(true)
    seTipo(tipo)
  }

  // Editar Ejercicio
  const [openEditarEjercicio, setOpenEditarEjercicio] = useState(false);

  const handleClickOpenEditar = (ejercicio: SeccionEjercicioState) => {
    const {tipo} = ejercicio;
    dispatch(setSeccionEjercicio(ejercicio));
    setOpenEditarEjercicio(true)
    seTipo(tipo)
  }

  // Eliminar Ejercicio

  const handleEliminarEjercicio = (ejercicio: SeccionEjercicioState) => {
    dispatch(eliminarSeccionEjercicio(ejercicio));
  }

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center my-3">
        <div className="spinner-border text-success" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <div>

      {/* Sección */}

      {
        openEliminar && <EliminarSeccion open={openEliminar} setOpen={setOpenEliminar} />
      }

      {
        openEditar && <EditarSeccion open={openEditar} setOpen={setOpenEditar} />
      }

      {/* Diapositiva */}

      {
        openEditarDiapositiva && <EditarDiapositiva open={openEditarDiapositiva} setOpen={setOpenEditarDiapositiva} />
      }

      {
        openEliminarDiapositiva && <EliminarDiapositiva open={openEliminarDiapositiva} setOpen={setOpenEliminarDiapositiva} />
      }

      {/* Ejercicio */}

      {
        openCrearEjercicio && <ModalCrearEjercicio tipo={tipo} open={openCrearEjercicio} setOpen={setOpenCrearEjercicio} />
      }

{
        openEditarEjercicio && <ModalEditarEjercicio tipo={tipo} open={openEditarEjercicio} setOpen={setOpenEditarEjercicio} />
      }

      {
        seccionesBloque.map(item => {
          const { sid, diapositivas, ejercicios } = item;
          return (
            <div key={sid} className="card-body" style={{ borderTop: 'solid 0.1px rgb(0,0,0,0.2)' }} >

              <div className='row justify-content-between align-items-center my-0'>
                <div className="col-auto">
                  <span style={{ fontWeight: 'bold', fontSize: '0.9em' }}><Latex>{item.nombre}</Latex></span>
                </div>
                <div className="col-auto">
                  <MenuSeccion
                    seccion={item}
                    handleEliminarSeccion={handleEliminarSeccion}
                    handleEditarSeccion={handleEditarSeccion}
                  />
                </div>
              </div>

              <div className='row justify-content-between align-items-center my-0'>
                <div className="col-auto">
                  <Modal bloque={bloque} seccion={item} />
                </div>
                <div className="col-auto">
                  {
                    diapositivas?.length === 0 ?
                      <IconButton
                        size='small'
                        onClick={() => handleCrearDiapositiva(item)}
                      >
                        <AddIcon fontSize='inherit' />
                      </IconButton> : (
                        <>
                          <IconButton
                            size='small'
                            onClick={() => handleEditarDiapositiva(item)}
                          >
                            <EditIcon fontSize='inherit' />
                          </IconButton>

                          <IconButton
                            size='small'
                            onClick={() => handleEliminarDiapositiva(item)}
                          >
                            <DeleteIcon fontSize='inherit' />
                          </IconButton>
                        </>
                      )
                  }
                </div>
              </div>

              {
                ejercicios && ejercicios?.length > 0 &&
                ejercicios?.map(item => {
                  const { eid } = item;
                  return (
                    <div className='row justify-content-between align-items-center my-0' key={eid}>
                      <div className="col-auto">
                        <IconButton onClick={() => console.log('Ejercicio Sección')}>
                          <CalculateIcon sx={{ color: '#3b5998' }} />
                        </IconButton>
                      </div>
                      <div className="col-auto">
                        <IconButton
                          size='small'
                          onClick={() => handleClickOpenEditar(item)}
                        >
                          <EditIcon fontSize='inherit' />
                        </IconButton>

                        <IconButton
                          size='small'
                          onClick={() => handleEliminarEjercicio(item)}
                        >
                          <DeleteIcon fontSize='inherit' />
                        </IconButton>
                      </div>
                    </div>
                  )
                })
              }

              <div className='row justify-content-between align-items-center my-0'>
                <div className="col-auto">
                  <IconButton
                    disabled
                  >
                    <CalculateIcon sx={{ color: 'lightgrey' }} />
                  </IconButton>
                </div>
                <div className="col-auto">
                  <MenuCrearEjercicio handleCrearEjercicio={handleCrearEjercicio} seccion={item} />
                </div>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default SeccionesEdicion